import type { FaireProductEntity } from "../../entity_types/product";

export const p_kbux3awsvk: FaireProductEntity = {
  token: "p_kbux3awsvk",
  type: "product",
  name: "Moroccan Cone Glassware Large - Clear",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/e0f922ad65fa1d6e3fac6694336b9637bbfd635ec01c05e5f8e56be8383ad8bc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/172a3a7a05fae708744558a7774c104bf1a4fa275d8e8b34c98a8ae937930480.jpeg",
    "https://cdn.faire.com/fastly/af6343b8f6d6580da2902b54d2f29eebb3fcbd039ae8d9fcf6d1bb64e20e6e66.jpeg",
    "https://cdn.faire.com/fastly/84c22145cc75956a05179ff15283753c226e0c82bfbdeeae04480afea1c02438.jpeg",
    "https://cdn.faire.com/fastly/2934c2a1e3f401d206ee76eee3f537acd14ba21211b9f99ee0c8ac1ac1b63ae7.jpeg",
    "https://cdn.faire.com/fastly/81fe4dc779d3ca6a3ba0ddff472c9684165117c3a6c6512d8f9ef2de6bdf26fb.jpeg",
    "https://cdn.faire.com/fastly/84be0b11d448f908237eb1f7d1cd6a708dc4d26272af85602fc6563ca2fc5968.jpeg",
    "https://cdn.faire.com/fastly/a34b8b95f0a48e73301dbffdc785a329a63d496ae475559651afd8e886fcadbc.jpeg",
  ],
  priceDollars: 4.2,
  description:
    '**Packaged in sets of 6** - 24 single glasses in a master\nSee separate listings for each color option.\n\nThe sleek and simple design of these hand-blown cone shaped glasses are a testament to the style and skill of the artisans who make them. Used for all types of beverages or as little vases to decorate each table setting, you will enjoy the feel of them in your hand as you toast the joys of the day. \n\nOur Moroccan glassware sets come in four distinct shades of transparent glass (Clear, Amber, Blue & Green). The handblown construction is evident in the bubbles suspended in the glass itself, and the organic forms that the vessels take.\n\nMade from recycled beer and wine bottles, these sets are a second act for glass that would otherwise be sent to landfills. \n\nLarge Cone: bottom diameter 3", top diameter 2.5" / 4.75" height. Capacity: 12 fl oz\n\nPackaged in sets of 6 in traditional Moroccan gift packaging.',
  tags: [],
  msrpDollars: 8.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:21.288Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
